/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TravelerDisabilityDiscountInformation } from './travelerDisabilityDiscountInformation';
import { TravelerRegulatoryDetails } from './travelerRegulatoryDetails';
import { TravelerIslandCard } from './travelerIslandCard';
import { TravelerNamesInner } from './travelerNamesInner';

/**
 * 予約詳細画面における搭乗者情報
 */
export interface Traveler {
  /**
   * 搭乗者ID
   */
  id?: string;
  /**
   * 名前情報
   */
  names?: Array<TravelerNamesInner>;
  /**
   * 搭乗者種別<br/> ADT：B15、CHD、INS、INFのいずれにも合致しない<br/> B15：DxAPIから返却された搭乗者種別がB15<br/> CHD：以下のいずれかに合致<br/> 1 搭乗者種別がCHD<br/> 2 搭乗者種別が\"U\" + 05~11の2桁の数字<br/> 3 搭乗者種別がUNN<br/> 4 SSR CHLDまたはUMNRがリレートしている<br/> INF：DxAPIから返却された搭乗者種別がINF<br/> INS：以下のいずれかに合致<br/> 1 DxAPIから返却された搭乗者種別がINS、<br/> 2 SSR INFTあり、かつINFINI作成PNR、かつフリーテキストに“OCCUPYING”が含まれる
   */
  passengerTypeCode?: Traveler.PassengerTypeCodeEnum;
  /**
   * 幼児同伴の大人<br/> NAMEエレメントに幼児情報がないが、SSR INFTがあり、SSR INFTが示す幼児が同伴幼児<br/> である搭乗者で場合true。SSR INFTがあり、かつINFINI作成PNRであり、かつフリー<br/> テキストに”OCCUPYING”が含まれない場合が該当。
   */
  hasInfiniNamelessInfant?: boolean;
  /**
   * 幼児情報不明<br/> NAMEエレメントに幼児情報がないが、SSR INFTがあり、SSR INFTが示す幼児が同伴幼児<br/> か席あり幼児かが判別できない搭乗者でである場合true。SSR INFTがあり、INFINI作成<br/> PNRでない場合が該当
   */
  hasNamelessInfant?: boolean;
  /**
   * 同伴する搭乗者のID<br/> 当該搭乗者が幼児の場合は同伴する大人のIDを、大人の場合は同伴する幼児のIDを返却
   */
  accompanyingTravelerId?: string;
  /**
   * 生年月日(yyyy/MM/dd形式)。<br/> 下記の優先順位で取得した生年月日を設定し、返却する。<br/> 1. 旅程区分が国際旅程の場合<br/>   1-1. SSR DOCSの生年月日(※1)<br/>   1-2. 空文字<br/> 2. 旅程区分が国内単独旅程の場合<br/>   2-1. SSR DOCSの生年月日(※1)<br/>   2-2. NAMEエレメントの生年月日<br/>   2-3. 空文字<br/> ※1：DxAPIから取得するRegulatory情報のうち、種別がpassportを対象とする。<br/> ただし、リクエストパラメータのマスキング要否がtrueの場合、\\*\\*\\*\\*_/\\*\\*_/\\*\\*の文字列。<br/> falseの場合、加工なしの文字列を返却する<br/> なお、上述の処理において空文字となった場合はマスキング要否に関わらず空文字を返却する。
   */
  dateOfBirth?: string;
  /**
   * 暗号化済み生年月日(yyyy/MM/dd形式)。リクエストパラメータのマスキング要否がtrueの場合のみ値を返却する。<br/> ※暗号化についてはAES方式とし、G03_共通処理（514_暗号化）を利用する。
   */
  encryptedDateOfBirth?: string;
  /**
   * 年齢<br/> DxAPIから生年月日または年齢が返却された場合に返却する。<br/> 生年月日が返却された場合はそれをもとに算出した値を、年齢が返却された場合はそれをそのまま年齢とする。<br/> リクエストパラメータのマスキング要否がtrueの場合、数値を*に置き換えた文字列を返却し、falseの場合、加工なしの文字列を返却する
   */
  age?: string;
  /**
   * 暗号化済み年齢。リクエストパラメータのマスキング要否がtrueの場合のみ値を返却する。<br/> ※暗号化についてはAES方式とし、G03_共通処理（514_暗号化）を利用する。
   */
  encryptedAge?: string;
  /**
   * 性別（male, female, unspecified, unknown）
   */
  gender?: string;
  regulatoryDetails?: TravelerRegulatoryDetails;
  /**
   * CHMLをお勧めする年齢か否か<br/> true：誕生日が登録されている、かつ第1便の出発日時時点での年齢がチャイルドミール初期選択年齢の上限以下<br/> ※チャイルドミール初期選択年齢は、設定ファイルにて定める
   */
  isChildMealRecommendedAge?: boolean;
  disabilityDiscountInformation?: TravelerDisabilityDiscountInformation;
  /**
   * 障がい者割運賃情報登録有無   障がい者種別がフリーテキストに登録されているRMが存在する場合、true：登録済みを返却
   */
  isDisabilityDiscountInformationRegistered?: boolean;
  islandCard?: TravelerIslandCard;
  /**
   * アイきっぷ運賃情報登録有無   離島カード番号がフリーテキストに登録されているRMが存在する場合、true：登録済みを返却
   */
  isIslandCardRegistered?: boolean;
}
export namespace Traveler {
  export type PassengerTypeCodeEnum = 'ADT' | 'B15' | 'CHD' | 'INF' | 'INS';
  export const PassengerTypeCodeEnum = {
    Adt: 'ADT' as PassengerTypeCodeEnum,
    B15: 'B15' as PassengerTypeCodeEnum,
    Chd: 'CHD' as PassengerTypeCodeEnum,
    Inf: 'INF' as PassengerTypeCodeEnum,
    Ins: 'INS' as PassengerTypeCodeEnum,
  };
}
